import { merchantApi } from '@/config/axios'

export interface MerchantPickUpStoreVO {
  id?: number
  name: string
  introduction?: string
  phone: string
  areaId?: number
  detailAddress: string
  logo: string
  openingTime?: string
  closingTime?: string
  latitude?: number
  longitude?: number
  status: number
  verifyUserIds?: number[]
  shopId?: number
}

export const getMinePickUpStore = async () => {
  return await merchantApi.get<MerchantPickUpStoreVO | null>({
    url: '/merchant-api/trade/delivery/pick-up-store/get-mine'
  })
}

export const saveMinePickUpStore = async (data: MerchantPickUpStoreVO) => {
  return await merchantApi.post<number>({
    url: '/merchant-api/trade/delivery/pick-up-store/save-mine',
    data
  })
}
